import script from "./department-select.vue?vue&type=script&setup=true&lang=js"
export * from "./department-select.vue?vue&type=script&setup=true&lang=js"

import "./department-select.vue?vue&type=style&index=0&id=0d87cea6&lang=scss&scoped=true"
import "./department-select.vue?vue&type=style&index=1&id=0d87cea6&lang=scss"
import "./department-select.vue?vue&type=style&index=2&id=0d87cea6&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d87cea6"]])

export default __exports__